import * as yup from 'yup';

export interface AdsAnalyticsResult {
  scriptUrl: string;
  crossDomains: string;
}

export interface AdsEntityParam {
  businessId?: string;
  employeeId?: string;
}

export const adsUrlSchema = yup.object({
  adsUrl: yup
    .string()
    .url('Must be a valid URL (e.g. https://yourwebsite.com)')
    .nullable()
    .default(null),
});

export type AdsUrlFormValues = yup.InferType<typeof adsUrlSchema>;
